import React, { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { Download, Printer } from "lucide-react";
import { api } from "@/lib/api";
import { useLang } from "@/contexts/LanguageContext";

export function SummaryActions() {
  const { t } = useLang();
  const [busy, setBusy] = useState(false);
  const download = async () => {
    setBusy(true);
    try {
      const r = await api.get("/reports/state-summary.pdf", { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = document.createElement("a");
      a.href = url; a.download = "MP-MSME-Credit-Summary.pdf"; a.click();
      URL.revokeObjectURL(url);
    } catch { toast.error(t("gs_pdf_error")); }
    setBusy(false);
  };
  return (
    <div className="flex flex-wrap gap-2">
      <button onClick={download} disabled={busy} data-testid="gov-download-pdf" className="inline-flex items-center gap-2 rounded-md bg-slate-900 text-white px-4 py-2 text-sm font-semibold hover:bg-slate-800 disabled:opacity-60">
        <Download className="w-4 h-4" /> {busy ? t("gs_preparing") : t("gs_download")}
      </button>
      <Link to="/gov/summary" target="_blank" data-testid="gov-print-summary" className="inline-flex items-center gap-2 rounded-md border border-slate-300 bg-white px-4 py-2 text-sm font-semibold text-slate-900 hover:border-slate-400">
        <Printer className="w-4 h-4" /> {t("gs_print")}
      </Link>
    </div>
  );
}
